export default {
  "product": {
    "product:autoMachineLearning": "Auto Machine Learning Platform",
    "product:modelDeployment": "AILM: Model Deployment",
    "product:anomalyDetection": "Anomaly Detection",
    "product:knowledgeManagement": "AILM: Knowledge Management",
    "product:adminService": "Admin Service",
    "product:onlineDeployment": "Online Deployment"
  },
  common: {
    profetAI: '杰伦智能科技',
    welcome: '欢迎登入',
    username: '使用者名称',
    onlineUsers: '在线的使用者',
    password: '密码',
    login: '登入',
    submit: '提交',
    resetPassword: '请重置密码',
    newPassword: '新密码',
    confirmPassword: '请确认新密码',
    changeSucceeded: '更改成功，请重新登入',
  }, // common
  validate: {
    isRequired: '{0} 不得为空',
    notEqual: '密码不一致，请确认两次密码相同',
    passValid: '密码需包含至少一个小写字母 [a-z]一个大写字母 [A-Z]一个数字 [0-9]且至少十个字元',
  }, // validate
  warning: {
    networkErr: '请检查网路连线环境是否顺畅',
  }, // warning
  serviceQuotaNotEnough: '使用者可用额度不足，请联络系统管理员。',
  cannotConnectLicenseServer: '无法连线至授权伺服器，请检查相关网路设定。',
  dbWrong: "资料库异常",
  WrongUserNameOrPassword: "请输入正确的使用者帐号与密码",
  AccountIsDisabled: "{0} 此帐号已停用，请联系系统管理员",
  RequiredPasswordChange: "请设定新密码",
  RequireAccountAndPassword: "使用者名称与密码不得为空",
  NeedAdminRole: "请联系系统管理员",
  userNotFound: "找不到此使用者",
  UnableToFindLicenseServer: "找不到授权伺服器位置",
  UnableToFindTargetAccountService: "找不到使用者帐号/目标服务",
  PasswordExpired: "密码已过期，请重新设定密码",
}